import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    sin: 'Repetir hombres distintos con el mismo patrón',
    con: 'Entendés qué atraés y por qué lo atraés'
  }, {
    sin: 'Vivir pendiente del último mensaje que mandó',
    con: 'Recuperás eje, paz mental y claridad'
  }, {
    sin: 'Aceptar migajas por miedo a quedarte sola',
    con: 'Subís tu estándar y dejás de conformarte'
  }, {
    sin: 'Confundir intensidad emocional con amor real',
    con: 'Aprendés a leer disponibilidad real desde el primer día'
  }, {
    sin: 'Tardar meses o años en soltar a un ex',
    con: 'Tenés protocolo de corte de lazos y detox emocional'
  }, {
    sin: 'Sentirte invisible o fácilmente reemplazable',
    con: 'Activás presencia, magnetismo y valor propio'
  }, {
    sin: 'Quedar atrapada en la ansiedad y la obsesión',
    con: 'Regulás tu sistema nervioso y tu campo energético'
  }];
  return <section className="py-20 px-4 bg-mystic-900" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-white mb-12" data-id="element-43">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="overflow-x-auto pb-4" data-id="element-44">
          <div className="min-w-[600px] bg-mystic-800/50 rounded-2xl border border-mystic-700 overflow-hidden" data-id="element-45">
            <div className="grid grid-cols-2 bg-mystic-800 border-b border-mystic-700" data-id="element-46">
              <div className="p-6 text-center font-bold text-slate-300" data-id="element-47">
                Sin El Código del Magnetismo
              </div>
              <div className="p-6 text-center font-bold text-gold-400 bg-gold-500/5" data-id="element-48">
                Con El Código del Magnetismo
              </div>
            </div>

            <div className="divide-y divide-mystic-700/50" data-id="element-49">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-mystic-800/30 transition-colors" data-id="element-50">
                  <div className="p-6 flex items-start gap-3" data-id="element-51">
                    <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-52" />
                    <span className="text-slate-300" data-id="element-53">{row.sin}</span>
                  </div>
                  <div className="p-6 flex items-start gap-3 bg-gold-500/5" data-id="element-54">
                    <Check className="w-5 h-5 text-gold-400 shrink-0 mt-0.5" data-id="element-55" />
                    <span className="text-slate-100 font-medium" data-id="element-56">
                      {row.con}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="text-center mt-4 text-sm text-slate-500 md:hidden" data-id="element-57">
          ← Scroll to see full table →
        </div>
      </div>
    </section>;
}